import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import useCmsData from "../../hook/useCmsData";
import PolicyPage from "../../components/PolicyPage";
import Loader from "../../components/Loader";

const TermsCondition = () => {
  const { cmsData, loading } = useCmsData();
  const policy = cmsData.find((item) => item?.title === "Terms and conditions");

  return (
    <>
      <Header />
      {loading && <Loader />}
      <PolicyPage title={policy?.title} content={policy?.content} />
      <Footer />
    </>
  );
};

export default TermsCondition;
